import clsx from 'clsx';
import { FC, ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components/Icon';
import { MODAL_CLOSE_BUTTON_TEST_ID } from 'components/Modal.const';

import styles from './CloseButton.module.scss';

export enum CloseButtonVariant {
  LIGHT = 'light',
  DARK = 'dark',
}

export type CloseButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & Readonly<{
  variant?: CloseButtonVariant;
  children?: never;
}>;

export const CloseButton: FC<CloseButtonProps> = ({ className, variant, ...props }) => {
  const [t] = useTranslation();
  const isLight = variant === CloseButtonVariant.LIGHT;

  return (
    <button
      type="button"
      aria-label={t('close')}
      data-testid={MODAL_CLOSE_BUTTON_TEST_ID}
      className={clsx(styles.closeButton, { [styles.light] : isLight, [styles.dark] : !isLight }, className)}
      {...props}
    >
      <Icon name={'close'} />
    </button>
  );
};
